import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RouteConstants from '../common/RouteConstants';
import { cacheStorage, Role } from '../helper';
import { jwtDecode } from 'jwt-decode';

export const PrivateRoute = ({ children, roles }) => {
    const location = useLocation();
    
    let currentUserLocalStorage = JSON.parse(localStorage.getItem('currentUser'));

    if (!currentUserLocalStorage) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    let jwt = currentUserLocalStorage && currentUserLocalStorage.token ? currentUserLocalStorage.token : '';
    const currentUser = jwtDecode(jwt);

    //Redirect to terms and condition if not accepted and user is not coach
    let cachedUser = JSON.parse(cacheStorage.getProfilePhotoFromLocalStorage('currentUser'));
    if (typeof cachedUser.termsAccepted == 'undefined' || (typeof cachedUser.termsAccepted !== 'undefined' && cachedUser.termsAccepted == false)) {
        return <Navigate to={RouteConstants.TERMS_AND_CONDITIONS} replace />;
    }

    // check if route is restricted by role
    if (roles && roles.indexOf(currentUser.role) === -1) {
        // role not authorised so redirect to home page
        return <Navigate to="/logout" replace />;
    }

    // authorised so return children
    return children;
};